import { Camera, Leaf, Ticket } from "lucide-react";
import { InstallAppButton } from "@/components/InstallAppButton";

const CHIPS = [
  { icon: Ticket, text: "Nomor tiket otomatis" },
  { icon: Camera, text: "Lampiran foto & video" },
];

export const HeroBanner = () => (
  <section className="fade-up relative overflow-hidden rounded-[28px] bg-slate-900 text-white shadow-2xl shadow-slate-900/20" data-testid="hero-banner">
    <img src="/images/hero-merak.jpg" alt="Jalan perumahan yang asri dan rindang" className="absolute inset-0 h-full w-full object-cover opacity-45" />
    <div className="absolute inset-0 bg-gradient-to-r from-slate-950 via-slate-900/90 to-emerald-950/40" />
    <div className="grain absolute inset-0" />
    <div className="relative px-6 py-10 sm:px-10 sm:py-14 lg:px-14 lg:py-16">
      <span className="inline-flex items-center gap-2 rounded-full border border-emerald-400/30 bg-emerald-400/10 px-3 py-1 text-xs font-semibold uppercase tracking-wider text-emerald-300">
        <Leaf className="h-3.5 w-3.5" /> Layanan Warga RT
      </span>
      <h2 className="mt-5 max-w-3xl font-heading text-4xl font-extrabold leading-[1.05] tracking-tight sm:text-5xl lg:text-6xl">
        Lingkungan nyaman dimulai dari <span className="text-emerald-400">laporan Anda.</span>
      </h2>
      <p className="mt-5 max-w-xl text-sm leading-relaxed text-slate-300 sm:text-base">
        Sampaikan keluhan seputar keamanan, kebersihan, fasilitas, drainase, hingga penghijauan di Cluster Merak.
        Pengurus RT mencatat dan menindaklanjuti setiap laporan secara terorganisir.
      </p>
      <div className="mt-7 flex flex-wrap items-center gap-2">
        {CHIPS.map(({ icon: Icon, text }) => (
          <span key={text} className="inline-flex items-center gap-2 rounded-full bg-white/10 px-3 py-1.5 text-xs font-medium text-white ring-1 ring-white/15 backdrop-blur">
            <Icon className="h-3.5 w-3.5 text-emerald-300" /> {text}
          </span>
        ))}
      </div>
      <div className="mt-6">
        <InstallAppButton variant="hero" />
        <p className="mt-2 text-xs text-slate-400">Akses cepat dari layar utama HP Anda, tanpa App Store.</p>
      </div>
    </div>
  </section>
);
